var React = require('react');

function Thankful (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"thankful","d":"M256,16C123.055,16,16,173.555,16,304c0,120.227,89.719,192,240,192s240-71.773,240-192C496,173.555,388.945,16,256,16Zm0,464C115.742,480,32,414.2,32,304,32,180.8,131.922,32,256,32S480,180.8,480,304C480,414.2,396.258,480,256,480ZM163.2,193.6,186.664,176,163.2,158.4a8,8,0,1,1,9.6-12.8l32,24a7.992,7.992,0,0,1,0,12.8l-32,24a8,8,0,1,1-9.6-12.8Zm144.008-11.2a7.992,7.992,0,0,1,0-12.8l31.992-24a8,8,0,1,1,9.6,12.8L325.336,176,348.8,193.6a8,8,0,1,1-9.6,12.8ZM368,224H144a8,8,0,0,0-8,8v16a72.079,72.079,0,0,0,72,72h96a72.079,72.079,0,0,0,72-72V232A8,8,0,0,0,368,224Zm-64,80H208a55.949,55.949,0,0,1-45.888-24H349.889A55.951,55.951,0,0,1,304,304Zm56-56a55.756,55.756,0,0,1-2.359,16H154.359A55.758,55.758,0,0,1,152,248v-8H360Z","transform":"translate(-16 -16)","fill":"#b152d5"}));
}

Thankful.defaultProps = {"viewBox":"0 0 480 480"};

module.exports = Thankful;

Thankful.default = Thankful;
